var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"travel-date-info"},[_c('div',{staticClass:"travel-date pf-medium"},[_c('div',[_vm._v(_vm._s(_vm.is602 ? '使用日期' : '游玩日期'))]),_c('div',[_vm._v(_vm._s(_vm.$$dateFormat(_vm.date, 'YY-MM-DD')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }